import React from 'react';
import { OEConnectEnvironment } from '../../../infrastructure/runtime-configuration';
import './website-input.scss';
import Text from '../text/text';

interface IProps {
    value: string;
    accountSubdomain?: string | null;
    onChange: (e?: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e?: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    postfix?: string;
}

const WebsiteInput = (props: IProps) => {
    const prefix = 'https://';
    const postfix = 'open-exchange.net/';

    const getPostfix = (): string => {
        if (props.postfix) return props.postfix;

        // @ts-ignore
        switch (window.OEConnectConfig.env) {
            case OEConnectEnvironment.Prod:
                return '.' + postfix;
            case OEConnectEnvironment.Stage:
                return '.stage-' + postfix;
            default:
                return '.dev-' + postfix;
        }
    };

    const passportUrlWithAccountSubdomain = `${prefix}${props.accountSubdomain}${getPostfix()}`;

    return (
        <div className={`website-input-wrapper ${props.className}`} >
            {props.accountSubdomain && (
                <div className="passport-url">
                    <Text message={passportUrlWithAccountSubdomain} withEllipsis />
                </div>
            )}
            <div className='website-input w-100'>
                {!props.accountSubdomain && <span className='website-input__prefix'>{prefix}</span>}
                <input
                    value={props.value || ''}
                    className='oe-form-field__control'
                    onBlur={props.onBlur}
                    onChange={props.onChange}
                    onKeyPress={e => (e.key === 'Enter' ? e.preventDefault() : null)}
                />
            </div>
            {!props.accountSubdomain && <div className='website-input__prefix'>{getPostfix()}</div>}
        </div>
    );
};

export default WebsiteInput;
